export function getDefaultOptions() {
    return {
        topserviceSelector: `.topservice-nav`,
        mainNavBarSelector: `.top-header`,
        hamburgerMenuSelector: `.menu-toggle`,  //nullable
        classes: {
            hide: `not-visible`,
            navbarOnTop: `glass`,   //nullable
        }
    };
}

export function initialize(_options = getDefaultOptions()) {
    console.log("Initializing top service.");

    const options = _options;
    let ticking = false;
    let lastScrollY;

    //#region  Safeguards
    let errorCode = 0;

    const topserviceNav = document.querySelector(options.topserviceSelector);
    if (!topserviceNav) {
        console.error("Top service nav was not found.");
        errorCode |= 1 << 0;
    }

    const navbar = document.querySelector(options.mainNavBarSelector);
    if (!navbar) {
        console.error("Main navbar was not found.");
        errorCode |= 1 << 1;
    }

    let hamburgerButton = null;
    if (options.hamburgerMenuSelector) {
        hamburgerButton = document.querySelector(options.hamburgerMenuSelector);
        if (!hamburgerButton) {
            console.error("Hamburger button was not found.");
            errorCode |= 1 << 2;
        }
    }

    if (errorCode !== 0) {
        console.error("Some components were not found. Error code: " + errorCode);
        return;
    }
    //#endregion
    
    lastScrollY = window.scrollY;

    topserviceNav.classList.toggle(options.classes.hide, window.scrollY >= 100);

    if (options.classes.navbarOnTop) {
        navbar.classList.toggle(options.classes.navbarOnTop, window.scrollY > 0);
    }

    if (hamburgerButton) {
        hamburgerButton.addEventListener(`click`, e => {
            topserviceNav.classList.remove(options.classes.hide);
        });
    }

    window.addEventListener(`scroll`, e => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                if (window.scrollY > lastScrollY && window.scrollY >= 100) {
                    topserviceNav.classList.add(options.classes.hide);
                }
                else if (window.scrollY < lastScrollY) {
                    topserviceNav.classList.remove(options.classes.hide);
                }

                if (options.classes.navbarOnTop != null) {
                    if (window.scrollY > lastScrollY && window.scrollY > 0) {
                        navbar.classList.add(options.classes.navbarOnTop);
                    } 
                    else if (window.scrollY < lastScrollY && window.scrollY === 0) {
                        navbar.classList.remove(options.classes.navbarOnTop);
                    }
                }

                lastScrollY = window.scrollY;
                ticking = false;
            });
        }
    });

    console.log("Top service initialized.");
}

